import { connect } from 'react-redux'
import * as selector from '../../../customer/state/detail/selector'
import WhatsAppTextWidget from './WhatsAppTextWidget'
import * as processSelector from '../../../process/state/instance-detail/selector'


const mapStateToProps = (state, props) => {
    return {
        customer: selector.selectCustomer(state),
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(WhatsAppTextWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/WhatsAppTextWidgetContainer.js